'use client';

import { Box, Flex, Button } from '@skin-seoul/design-system';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import LegacyInstagramIcon from '@/assets/LegacyInstagramIcon';
import LucideIcon from '@/components/ui/LucideIcon';
import SectionHeader from '../../components/SectionHeader';
import { Carousel, type CarouselApi } from '@/components/ui/Carousel/Carousel';
import VideoCard from './components/VideoCard/VideoCard';
import { TRENDING_VIDEOS } from '@skin-seoul/service';
import { useState } from 'react';
import { useSafeRouter } from '@/hooks';
const TrendingNowSection = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [activeVideoId, setActiveVideoId] = useState<string | null>(null);
  const {
    push
  } = useSafeRouter();
  const handlePrevClick = () => {
    api?.scrollPrev();
  };
  const handleNextClick = () => {
    api?.scrollNext();
  };
  return <SectionContainer containerInnerProps={{
    backgroundColor: 'generic.100',
    paddingY: {
      base: 8,
      tablet: 12,
      desktop: 16
    }
  }} data-sentry-element="SectionContainer" data-sentry-component="TrendingNowSection" data-sentry-source-file="TrendingNowSection.tsx">
      <Flex direction="column" width="100%" gap={{
      base: 6,
      tablet: 8,
      desktop: 12
    }} data-sentry-element="Flex" data-sentry-source-file="TrendingNowSection.tsx">
        <SectionHeader href="/trend/" title="Trending Now" theme="dark" data-sentry-element="SectionHeader" data-sentry-source-file="TrendingNowSection.tsx" />

        <Box position="relative" width="100%" data-sentry-element="Box" data-sentry-source-file="TrendingNowSection.tsx">
          <Carousel opts={{
          align: 'start',
          slidesToScroll: 1,
          containScroll: 'trimSnaps',
          loop: true
        }} setApi={setApi} data-sentry-element="Carousel" data-sentry-source-file="TrendingNowSection.tsx">
            <Carousel.Content data-sentry-element="Carousel.Content" data-sentry-source-file="TrendingNowSection.tsx">
              {TRENDING_VIDEOS.map(video => <Carousel.Item key={video.id} flexBasis={{
              base: '45%',
              tablet: '45%',
              desktop: '30%'
            }} marginRight={{
              base: 4,
              tablet: 6
            }}>
                  <VideoCard {...video} onClick={() => push(video.productLink)} activeVideoId={activeVideoId} onUnmute={setActiveVideoId} />
                </Carousel.Item>)}
            </Carousel.Content>

            <Button onClick={handlePrevClick} position="absolute" left={{
            tablet: '2',
            desktop: '4'
          }} top="50%" transform="translateY(-50%)" backgroundColor="generic.0" color="generic.100" borderRadius="24px" width="48px" height="48px" padding="0" minWidth="auto" display={{
            base: 'none',
            tablet: 'flex'
          }} alignItems="center" justifyContent="center" boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)" _hover={{
            backgroundColor: 'neutral.50',
            transform: 'translateY(-50%) scale(1.1)'
          }} _active={{
            backgroundColor: 'neutral.100'
          }} data-sentry-element="Button" data-sentry-source-file="TrendingNowSection.tsx">
              <LucideIcon name="ChevronLeft" boxSize={6} data-sentry-element="LucideIcon" data-sentry-source-file="TrendingNowSection.tsx" />
            </Button>

            <Button onClick={handleNextClick} position="absolute" right={{
            tablet: '2',
            desktop: '4'
          }} top="50%" transform="translateY(-50%)" backgroundColor="generic.0" color="generic.100" borderRadius="24px" width="48px" height="48px" padding="0" minWidth="auto" display={{
            base: 'none',
            tablet: 'flex'
          }} alignItems="center" justifyContent="center" boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)" _hover={{
            backgroundColor: 'neutral.50',
            transform: 'translateY(-50%) scale(1.1)'
          }} _active={{
            backgroundColor: 'neutral.100'
          }} data-sentry-element="Button" data-sentry-source-file="TrendingNowSection.tsx">
              <LucideIcon name="ChevronRight" boxSize={6} data-sentry-element="LucideIcon" data-sentry-source-file="TrendingNowSection.tsx" />
            </Button>
          </Carousel>
        </Box>

        <Box textAlign="center" marginTop={{
        base: 4,
        tablet: 6
      }} data-sentry-element="Box" data-sentry-source-file="TrendingNowSection.tsx">
          <SafeLink unstyled href="https://www.instagram.com/skinseoul.official/?hl=en" target="_blank" rel="noopener noreferrer" width={{
          base: 'full',
          tablet: '332px'
        }} data-sentry-element="SafeLink" data-sentry-source-file="TrendingNowSection.tsx">
            <Button backgroundColor="transparent" border="1px solid" borderColor="generic.0" borderRadius="8px" color="generic.0" textStyle="paragraph.small" fontWeight="regular" height="48px" padding={4} width={{
            base: 'full',
            tablet: '332px'
          }} _hover={{
            backgroundColor: 'neutral.700'
          }} _active={{
            backgroundColor: 'generic.0',
            borderColor: 'generic.0',
            color: 'generic.100'
          }} data-sentry-element="Button" data-sentry-source-file="TrendingNowSection.tsx">
              Follow us on <LegacyInstagramIcon data-sentry-element="LegacyInstagramIcon" data-sentry-source-file="TrendingNowSection.tsx" />
            </Button>
          </SafeLink>
        </Box>
      </Flex>
    </SectionContainer>;
};
export default TrendingNowSection;